/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type AccountNavContent_viewer$ref = any;
export type AccountNav_viewer$ref = any;
export type AccountNav_viewer = {
    readonly " $fragmentRefs": AccountNavContent_viewer$ref;
    readonly " $refType": AccountNav_viewer$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "AccountNav_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "AccountNavContent_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'c3ac0a44332509c1ef9d29b8c32a830c';
export default node;
